export default "__VITE_ASSET__DMzZwEu7__"